import { FC } from "react";
import { SanityVideoYoutube } from "../../graphql-types";
import Video from "./Video";

export interface VideoYoutubeBlockProps {
  value: SanityVideoYoutube;
}

const VideoYoutubeBlock: FC<VideoYoutubeBlockProps> = ({ value }) => {
  return (
    <Video
      title={value.title}
      url={"https://www.youtube.com/watch?v=" + value.videoId}
    />
  );
};

export default VideoYoutubeBlock;
